import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './workbench.module.scss';
import arrow_down from '../../static/images_pfizer/assistant/arrow_down.png';
import green_arrow_right from '../../static/images_pfizer/assistant/green_arrow_right.png';
import assistant_doctor_avatar from '../../static/images_pfizer/assistant/assistant_doctor_avatar.png';
import location from '../../static/images_pfizer/assistant/location.png';
import no_related_doctor from '../../static/images_pfizer/assistant/no_related_doctor.png';
import { Button } from 'antd-mobile-v5';
import  { ApiCore } from '../../api/index';
import { withRouter } from 'react-router-dom';

const api = new ApiCore();

function Workbench(props: any) {

    const [list, setList] = useState([]);
    const [hasDoctor, setHasDoctor] = useState<any>(null);

    useEffect(() => {
        document.title = '首页';
        getTeamDoctors();
        return () => {
        }
    }, [])

    const getTeamDoctors = () => {
        api.getTeamDoctors().then((res: any) => {
            if (res.code == 0) {
                setList(res.data || []);
                if ((res.data || []).length > 0) {
                    setHasDoctor(true);
                } else {
                    setHasDoctor(false);
                }
            }
        })
    }

    return (
        <div className={`${styles.workbench_content}`}>
            {/* <div className={styles.head_bg}>
            </div> */}
            <div className={styles.head_middle}>
                <div className={styles.middle_left}>
                    <div className={styles.left_border}></div>
                    <div className={styles.left_text}>我的协管医生</div>
                </div>
                <div className={styles.middle_right} onClick={ () => { props.history.push('/pfizer/assistant/allDoctors'); } }>
                    <span>全部医生</span>
                    <img src={green_arrow_right} alt="" />
                </div>
            </div>
            {
                list && list.map((val: any, key: number) => (
                <div key={key} className={styles.head_content}>
                    <div className={styles.content_card}>
                        <div className={styles.card_top}>
                            <div className={styles.top_left}>
                                <img src={assistant_doctor_avatar} alt="" />
                            </div>
                            <div className={styles.top_middle}>
                                <div className={styles.top_middle_head}>
                                    <span>{val.doctorName}</span>
                                    <span>{val.jobTitle}</span>
                                </div>
                                <div className={styles.top_middle_middle}>
                                    <span>{val.hospital}</span>
                                    <span>{val.dept}</span>
                                </div>
                                {
                                    (val.groupTasks || []).map((item: any) => (
                                        <div className={styles.top_middle_bottom}>{item.groupName || ''}</div>
                                    ))
                                }
                            </div>
                            {/* {
                                val.state &&
                                <div className={styles.top_right}>
                                    <div className={styles.top_right_button}>活跃中</div>
                                </div>
                            } */}
                        </div>
                        {/* <div className={styles.card_middle_line}></div>
                        <div className={styles.card_bottom}>
                            <div className={styles.bottom_left}>
                                <div>NP / OP</div>
                                <div>26 / 33</div>
                            </div>
                            <div className={styles.bottom_right}>
                                <div>任务</div>
                                <div>15 / 30</div>
                            </div>
                        </div> */}
                    </div>
                </div>
                ))
            }
            {
                hasDoctor === false && 
                <>
                    <div className={styles.no_related_doctor_wrap}>
                        <img src={no_related_doctor} alt="" />
                    </div>
                    <div className={styles.related_btn}>
                        <Button color='primary' onClick={() => { props.history.push('/pfizer/assistant/addDoctor') }}>立即申请关联</Button>  
                    </div>
                </>
            }

        </div>
    )

}

export default withRouter(Workbench);